"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OceanAgreementsConditions = void 0;
var Instantiable_abstract_1 = require("../Instantiable.abstract");
var OceanAgreementsConditions = (function (_super) {
    __extends(OceanAgreementsConditions, _super);
    function OceanAgreementsConditions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OceanAgreementsConditions.getInstance = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var instance;
            return __generator(this, function (_a) {
                instance = new OceanAgreementsConditions();
                instance.setInstanceConfig(config);
                return [2, instance];
            });
        });
    };
    OceanAgreementsConditions.prototype.lockReward = function (agreementId, amount, from) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, lockRewardCondition, escrowReward, receipt, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.ocean.keeper.conditions, lockRewardCondition = _a.lockRewardCondition, escrowReward = _a.escrowReward;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4, this.ocean.keeper.token.approve(lockRewardCondition.getAddress(), amount, from.getId())];
                    case 2:
                        _c.sent();
                        return [4, lockRewardCondition.fulfill(agreementId, escrowReward.getAddress(), amount, from && from.getId())];
                    case 3:
                        receipt = _c.sent();
                        return [2, !!receipt.events.Fulfilled];
                    case 4:
                        _b = _c.sent();
                        return [2, false];
                    case 5: return [2];
                }
            });
        });
    };
    OceanAgreementsConditions.prototype.grantAccess = function (agreementId, did, grantee, from) {
        return __awaiter(this, void 0, void 0, function () {
            var accessSecretStoreCondition, receipt, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        accessSecretStoreCondition = this.ocean.keeper.conditions.accessSecretStoreCondition;
                        return [4, accessSecretStoreCondition.fulfill(agreementId, did, grantee, from && from.getId())];
                    case 1:
                        receipt = _b.sent();
                        return [2, !!receipt.events.Fulfilled];
                    case 2:
                        _a = _b.sent();
                        return [2, false];
                    case 3: return [2];
                }
            });
        });
    };
    OceanAgreementsConditions.prototype.grantCompute = function (agreementId, did, grantee, from) {
        return __awaiter(this, void 0, void 0, function () {
            var computeExecutionCondition, receipt, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        computeExecutionCondition = this.ocean.keeper.conditions.computeExecutionCondition;
                        return [4, computeExecutionCondition.fulfill(agreementId, did, grantee, from && from.getId())];
                    case 1:
                        receipt = _b.sent();
                        return [2, !!receipt.events.Fulfilled];
                    case 2:
                        _a = _b.sent();
                        return [2, false];
                    case 3: return [2];
                }
            });
        });
    };
    OceanAgreementsConditions.prototype.releaseReward = function (agreementId, amount, did, consumer, publisher, from) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, escrowReward, accessSecretStoreCondition, lockRewardCondition, conditionIdAccess, conditionIdLock, receipt, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, , 5]);
                        _a = this.ocean.keeper.conditions, escrowReward = _a.escrowReward, accessSecretStoreCondition = _a.accessSecretStoreCondition, lockRewardCondition = _a.lockRewardCondition;
                        return [4, accessSecretStoreCondition.generateIdHash(agreementId, did, consumer)];
                    case 1:
                        conditionIdAccess = _c.sent();
                        return [4, lockRewardCondition.generateIdHash(agreementId, escrowReward.getAddress(), amount)];
                    case 2:
                        conditionIdLock = _c.sent();
                        return [4, escrowReward.fulfill(agreementId, amount, publisher, consumer, conditionIdLock, conditionIdAccess, from && from.getId())];
                    case 3:
                        receipt = _c.sent();
                        return [2, !!receipt.events.Fulfilled];
                    case 4:
                        _b = _c.sent();
                        return [2, false];
                    case 5: return [2];
                }
            });
        });
    };
    return OceanAgreementsConditions;
}(Instantiable_abstract_1.Instantiable));
exports.OceanAgreementsConditions = OceanAgreementsConditions;
//# sourceMappingURL=OceanAgreementsConditions.js.map